export default "__VITE_ASSET__a8b58feb__"